import FetchStatusRepository   from "../../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository        from "../../../../domain/fundamentals/message/notify/NotifyRepository";
import MailSetting             from "../../../../domain/mail/setting/MailSetting";
import MailSettingRepository   from "../../../../domain/mail/setting/MailSettingRepository";
import FetchStatusDataSource   from "../../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import MailSettingDataSource   from "../../../../infrastructure/datasource/mail/setting/MailSettingDataSource";
import NotifyDataSource        from "../../../../infrastructure/datasource/notify/NotifyDataSource";
import SetValidateErrorMessage from "../../error/SetValidateErrorMessage";

class UpdateMailSetting {
  private readonly mailSettingRepository: MailSettingRepository = new MailSettingDataSource(this.dispatch);
  private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(this.dispatch);
  private readonly notifyRepository: NotifyRepository = new NotifyDataSource(this.dispatch);
  private readonly setValidateErrorMessage: SetValidateErrorMessage = new SetValidateErrorMessage(this.dispatch);

  constructor(private readonly dispatch) {
  }

  public async execute(mailSetting: MailSetting) {
    this.fetchStatusRepository.start();
    try {
      await this.mailSettingRepository.update(mailSetting);
      this.notifyRepository.saveSuccess();
    } catch (e) {
      this.setValidateErrorMessage.execute(e);
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default UpdateMailSetting;
